import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';

import { getValidHtmlAttributes } from '@bibliocommons/utils-html';
import { bindAll } from '@bibliocommons/utils-react';
import { childrenShape } from '@bibliocommons/bc-prop-types';
import { ChevronDown } from '@bibliocommons/base-icons';

import SelectOption from './SelectOption';

import './Select.scss';

export default class Select extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleChange(event) {
    this.props.handleChange(event.target.value);
  }

  render() {
    const { className, children, flat, block, disabled, prompt, value, dataKey } = this.props;
    const classNames = cn('cp-select', className, {
      'select--block': block,
      'select--disabled': disabled
    });

    return (
      <div className={classNames}>
        <select
          {...getValidHtmlAttributes(this.props, 'select')}
          className={cn('select__select', { 'select__select--flat': flat })}
          data-key={dataKey}
          value={value || ''}
          onChange={this.handleChange}
        >
          <SelectOption key="prompt" value="" disabled>
            {prompt}
          </SelectOption>
          {children}
        </select>
        <ChevronDown className="select__chevron" />
      </div>
    );
  }
}

Select.propTypes = {
  className: PropTypes.string,
  children: childrenShape.isRequired,
  id: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  handleChange: PropTypes.func.isRequired,
  dataKey: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  prompt: PropTypes.string.isRequired,
  flat: PropTypes.bool,
  block: PropTypes.bool,
  disabled: PropTypes.bool
};
